// removed by extract-text-webpack-plugin
module.exports = {"progressButton--icon":"index__progressButton--icon--Bxdw3"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/ProgressButton/styles/index.scss
// module id = oJma
// module chunks = 23